import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useLogs from '../useLogs';

const MainPage = () => {
  const { t } = useTranslation();
  const {
    columns,
    data,
    loading,
    onChangeTableFilter,
    filters,
    handleDownloadExcel,
  } = useLogs();

  return (
    <>
      <PageHeader title={t('LOGS').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters}/>
        <Divider />
        <Table
          columns={columns}
          dataSource={data.gdprlogs}
          pagination={data.pagination}
          scroll={{ x: 1000 }}
          loading={loading}
          onChange={onChangeTableFilter}
        />
      </div>
    </>
  );
};

export default MainPage;
